<template>
    <section class="contain">
        <div class="inner" :style="{ minHeight: screenHeight }">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h1 class="panel-title">Hotel Assistance</h1>
                </div>
                <div class="panel-body">
                    <p>
                        If you would like more information about other room
                        types offered by the hotel or need any assistance with
                        your booking, please email the hotel at
                        <a
                            class="my-link"
                            href="mailto:london.concierge@rosewoodhotels.com"
                            >london.concierge@rosewoodhotels.com</a
                        >
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data: () => ({
        screenHeight: window.innerHeight + "px",
    }),
};
</script>
